import { arrowRight_16 as arrowRight16 } from "@trustpilot/icons";
import React from "react";

import { CompanyIcon } from "./companyIcon";
import {
  OrganizationIconArea,
  CenteredDiv,
  AccountNameContainer,
  ArrowIcon,
  CenteredPulledRightDiv,
  StyledAccountsListItem,
} from "./styled";
import * as Types from "./types";

const AccountsListItem: React.FC<Types.AccountsListItem> = ({ businessAccount, onClick }) => (
  <StyledAccountsListItem onClick={() => onClick(businessAccount)}>
    <CenteredDiv>
      <OrganizationIconArea>
        <CompanyIcon />
      </OrganizationIconArea>
    </CenteredDiv>
    <AccountNameContainer data-testid="accountSelectorAccountItem">{businessAccount.name}</AccountNameContainer>
    <CenteredPulledRightDiv>
      <ArrowIcon content={arrowRight16} color={"var(--neutral-stone-98)"} />
    </CenteredPulledRightDiv>
  </StyledAccountsListItem>
);

export default AccountsListItem;
